export default "__VITE_ASSET__DVS0PIfe__";